import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { GameContext, GameContextProps } from "../contexts";
import healthPoint from "../assets/icons/health-point.png";

/**Displays the current energy of the player, recieved from the GameContext. */
export const EnergyMeter = () => {
    const {currentEnergy} = useContext(GameContext) as GameContextProps;
    const symbol = "♦";
    const initialEnergyMeter = Array(currentEnergy).fill(symbol);
    const [exhaustionDisplay, setDisplay] = useState(initialEnergyMeter);

    useEffect(() => {
        if (currentEnergy <= 0) {
            const emptyEnergyMeter = ["-"];
            setDisplay(emptyEnergyMeter);
            return;
        }
        const currentEnergyMeter = Array(currentEnergy).fill(symbol);
        setDisplay(currentEnergyMeter);
    }, [currentEnergy])

    return (
        <div className="energy-container">
            <p>Energy</p>
            <Box data-testid="energy-meter" className="energy-meter">
                {exhaustionDisplay.map((item, index) => {
                    if (currentEnergy <= 0) return <p key={index}>-</p>
                    return <img src={healthPoint} key={index} alt="♦"/>
                })}
            </Box>
        </div>
    );
}


